<template>
    <div style="height: 100vh;">
        <iframe
            :src="file_source"
            width="100%"
            height="100%"
            frameborder="0"
        />
    </div>
</template>

<script>
export default {
    data() {
        return {
            file_source: "",
        }
    },
    created() {
        const fileURL = `${window.location.origin}/docs/terms-and-conditions.docx`
        this.file_source = `https://docs.google.com/gview?url=${encodeURIComponent(fileURL)}&embedded=true`
    },
}
</script>

<style lang="css" scoped>
    .reset-this,
    .reset-this a, 
    .reset-this abbr, 
    .reset-this address, 
    .reset-this area, 
    .reset-this article, 
    .reset-this aside, 
    .reset-this div, 
    .reset-this kbd, 
    .reset-this keygen, 
    .reset-this label, 
    .reset-this legend, 
    .reset-this li, 
    .reset-this link, 
    .reset-this map, 
    .reset-this mark, 
    .reset-this menu, 
    .reset-this meta, 
    .reset-this meter, 
    .reset-this nav, 
    .reset-this noscript, 
    .reset-this object, 
    .reset-this ol, 
    .reset-this optgroup, 
    .reset-this option, 
    .reset-this output, 
    .reset-this p, 
    .reset-this param,
    .reset-this pre, 
    .reset-this progress, 
    .reset-this q, 
    .reset-this rp, 
    .reset-this rt, 
    .reset-this ruby, 
    .reset-this s, 
    .reset-this samp, 
    .reset-this script, 
    .reset-this section, 
    .reset-this select, 
    .reset-this small, 
    .reset-this source, 
    .reset-this span, 
    .reset-this strong,
    .reset-this style, 
    .reset-this sub, 
    .reset-this summary, 
    .reset-this sup, 
    .reset-this table, 
    .reset-this tbody, 
    .reset-this td, 
    .reset-this textarea, 
    .reset-this tfoot, 
    .reset-this th, 
    .reset-this thead, 
    .reset-this time, 
    .reset-this title, 
    .reset-this tr, 
    .reset-this track, 
    .reset-this u, 
    .reset-this ul, 
    .reset-this var, 
    .reset-this video, 
    .reset-this wbr {
        animation : none;
        animation-delay : 0;
        animation-direction : normal;
        animation-duration : 0;
        animation-fill-mode : none;
        animation-iteration-count : 1;
        animation-name : none;
        animation-play-state : running;
        animation-timing-function : ease;
        backface-visibility : visible;
        background : 0;
        background-attachment : scroll;
        background-clip : border-box;
        background-color : transparent;
        background-image : none;
        background-origin : padding-box;
        background-position : 0 0;
        background-position-x : 0;
        background-position-y : 0;
        background-repeat : repeat;
        background-size : auto auto;
        border : 0;
        border-style : none;
        border-width : medium;
        border-color : inherit;
        border-bottom : 0;
        border-bottom-color : inherit;
        border-bottom-left-radius : 0;
        border-bottom-right-radius : 0;
        border-bottom-style : none;
        border-bottom-width : medium;
        border-collapse : separate;
        border-image : none;
        border-left : 0;
        border-left-color : inherit;
        border-left-style : none;
        border-left-width : medium;
        border-radius : 0;
        border-right : 0;
        border-right-color : inherit;
        border-right-style : none;
        border-right-width : medium;
        border-spacing : 0;
        border-top : 0;
        border-top-color : inherit;
        border-top-left-radius : 0;
        border-top-right-radius : 0;
        border-top-style : none;
        border-top-width : medium;
        bottom : auto;
        box-shadow : none;
        box-sizing : content-box;
        caption-side : top;
        clear : none;
        clip : auto;
        color : inherit;
        columns : auto;
        column-count : auto;
        column-fill : balance;
        column-gap : normal;
        column-rule : medium none currentColor;
        column-rule-color : currentColor;
        column-rule-style : none;
        column-rule-width : none;
        column-span : 1;
        column-width : auto;
        content : normal;
        counter-increment : none;
        counter-reset : none;
        cursor : auto;
        direction : ltr;
        display : inline;
        empty-cells : show;
        float : none;
        font : normal;
        font-family : inherit;
        font-size : medium;
        font-style : normal;
        font-variant : normal;
        font-weight : normal;
        height : auto;
        hyphens : none;
        left : auto;
        letter-spacing : normal;
        line-height : normal;
        list-style : none;
        list-style-image : none;
        list-style-position : outside;
        list-style-type : disc;
        margin : 0;
        margin-bottom : 0;
        margin-left : 0;
        margin-right : 0;
        margin-top : 0;
        max-height : none;
        max-width : none;
        min-height : 0;
        min-width : 0;
        opacity : 1;
        orphans : 0;
        outline : 0;
        outline-color : invert;
        outline-style : none;
        outline-width : medium;
        overflow : visible;
        overflow-x : visible;
        overflow-y : visible;
        padding : 0;
        padding-bottom : 0;
        padding-left : 0;
        padding-right : 0;
        padding-top : 0;
        page-break-after : auto;
        page-break-before : auto;
        page-break-inside : auto;
        perspective : none;
        perspective-origin : 50% 50%;
        position : static;
        /* May need to alter quotes for different locales (e.g fr) */
        quotes : '\201C' '\201D' '\2018' '\2019';
        right : auto;
        tab-size : 8;
        table-layout : auto;
        text-align : inherit;
        text-align-last : auto;
        text-decoration : none;
        text-decoration-color : inherit;
        text-decoration-line : none;
        text-decoration-style : solid;
        text-indent : 0;
        text-shadow : none;
        text-transform : none;
        top : auto;
        transform : none;
        transform-style : flat;
        transition : none;
        transition-delay : 0s;
        transition-duration : 0s;
        transition-property : none;
        transition-timing-function : ease;
        unicode-bidi : normal;
        vertical-align : baseline;
        visibility : visible;
        white-space : normal;
        widows : 0;
        width : auto;
        word-spacing : normal;
        z-index : auto;
    }
    .reset-this html {
     display: block;
    }
    .reset-this head,
    .reset-this link,
    .reset-this meta,
    .reset-this script,
    .reset-this style,
    .reset-this title {
      display: none;
    }
    .reset-this body {
      display: block;
      margin: 8px;
    }
    .reset-this p {
      display: block;
      margin-top: 1em;
      margin-bottom: 1em;
      margin-left: 0;
      margin-right: 0;
      margin: 1em 0;
    }
    .reset-this address,
    .reset-this article,
    .reset-this aside,
    .reset-this div,
    .reset-this footer,
    .reset-this header,
    .reset-this hgroup,
    .reset-this layer,
    .reset-this main,
    .reset-this nav,
    .reset-this section {
      display: block;
    }
    .reset-this marquee {
      display: inline-block;
      overflow: -webkit-marquee;
    }
    .reset-this blockquote {
      display: block;
      margin-top: 1em;
      margin-bottom: 1em;
      margin-left: 40px;
      margin-right: 40px;
      margin: 1em 40px;
    }
    .reset-this figcaption {
      display: block;
    }
    .reset-this figure {
      display: block;
      margin-top: 1em;
      margin-bottom: 1em;
      margin-left: 40px;
      margin-right: 40px;
      margin: 1em 40px;
    }
    .reset-this q {
      display: inline;
    }
    .reset-this q::before {
      content: open-quote;
    }
    .reset-this q::after {
      content: close-quote;
    }
    .reset-this center {
      display: block;
      text-align: -webkit-center;
    }
    .reset-this hr {
      display: block;
      margin-top: 0.5em;
      margin-bottom: 0.5em;
      margin-left: auto;
      margin-right: auto;
      margin: 0.5em auto;
      border-style: inset;
      border-width: 1px;
    }
    .reset-this video {
      object-fit: contain;
    }
    .reset-this h1 {
      display: block;
      font-size: 2em;
      margin-top: 0.67em;
      margin-bottom: 0.67em;
      margin-left: 0;
      margin-right: 0;
      margin: 0.67em 0;
      font-weight: bold;
    }
    .reset-this :matches(article,
    .reset-this aside,
    .reset-this nav,
    .reset-this section) h1 {
      font-size: 1.5em;
      margin-top: 0.83em;
      margin-bottom: 0.83em;
      margin: 0.83em 0;
    }
    .reset-this :matches(article,
    .reset-this aside,
    .reset-this nav,
    .reset-this section) :matches(article,
    .reset-this aside,
    .reset-this nav,
    .reset-this section) h1 {
      font-size: 1.17em;
      margin-top: 1em;
      margin-bottom: 1em;
      margin: 1em 0;
    }
    .reset-this :matches(article,
    .reset-this aside,
    .reset-this nav,
    .reset-this section) :matches(article,
    .reset-this aside,
    .reset-this nav,
    .reset-this section) :matches(article,
    .reset-this aside,
    .reset-this nav,
    .reset-this section) h1 {
      font-size: 1.00em;
      margin-top: 1.33em;
      margin-bottom: 1.33em;
      margin: 1.33em 0;
    }
    .reset-this :matches(article,
    .reset-this aside,
    .reset-this nav,
    .reset-this section) :matches(article,
    .reset-this aside,
    .reset-this nav,
    .reset-this section) :matches(article,
    .reset-this aside,
    .reset-this nav,
    .reset-this section) :matches(article,
    .reset-this aside,
    .reset-this nav,
    .reset-this section) h1 {
      font-size: .83em;
      margin-top: 1.67em;
      margin-bottom: 1.67em;
      margin: 1.67em 0;
    }
    .reset-this :matches(article,
    .reset-this aside,
    .reset-this nav,
    .reset-this section) :matches(article,
    .reset-this aside,
    .reset-this nav,
    .reset-this section) :matches(article,
    .reset-this aside,
    .reset-this nav,
    .reset-this section) :matches(article,
    .reset-this aside,
    .reset-this nav,
    .reset-this section) :matches(article,
    .reset-this aside,
    .reset-this nav,
    .reset-this section) h1 {
      font-size: .67em;
      margin-top: 2.33em;
      margin-bottom: 2.33em;
      margin: 2.33em 0;
    }
    .reset-this h2 {
      display: block;
      font-size: 1.5em;
      margin-top: 0.83em;
      margin-bottom: 0.83em;
      margin-left: 0;
      margin-right: 0;
      margin: 0.83em 0;
      font-weight: bold;
    }
    .reset-this h3 {
      display: block;
      font-size: 1.17em;
      margin-top: 1em;
      margin-bottom: 1em;
      margin-left: 0;
      margin-right: 0;
      margin: 1em 0;
      font-weight: bold;
    }
    .reset-this h4 {
      display: block;
      margin-top: 1.33em;
      margin-bottom: 1.33em;
      margin-left: 0;
      margin-right: 0;
      margin: 1.33em 0;
      font-weight: bold;
    }
    .reset-this h5 {
      display: block;
      font-size: .83em;
      margin-top: 1.67em;
      margin-bottom: 1.67em;
      margin-left: 0;
      margin-right: 0;
      margin: 1.67em 0;
      font-weight: bold;
    }
    .reset-this h6 {
      display: block;
      font-size: .67em;
      margin-top: 2.33em;
      margin-bottom: 2.33em;
      margin-left: 0;
      margin-right: 0;
      margin: 2.33em 0;
      font-weight: bold;
    }
    .reset-this table {
      display: table;
      border-collapse: separate;
      border-spacing: 2px;
      border-color: gray;
    }
    .reset-this thead {
      display: table-header-group;
      vertical-align: middle;
      border-color: inherit;
    }
    .reset-this tbody {
      display: table-row-group;
      vertical-align: middle;
      border-color: inherit;
    }
    .reset-this tfoot {
      display: table-footer-group;
      vertical-align: middle;
      border-color: inherit;
    }
    .reset-this table > tr {
      vertical-align: middle;
    }
    .reset-this col {
      display: table-column;
    }
    .reset-this colgroup {
      display: table-column-group;
    }
    .reset-this tr {
      display: table-row;
      vertical-align: inherit;
      border-color: inherit;
    }
    .reset-this td,
    .reset-this th {
      display: table-cell;
      vertical-align: inherit;
    }
    .reset-this th {
      font-weight: bold;
    }
    .reset-this caption {
      display: table-caption;
      text-align: -webkit-center;
    }
    .reset-this ul,
    .reset-this menu,
    .reset-this dir {
      display: block;
      list-style-type: disc;
      margin-top: 1em;
      margin-bottom: 1em;
      margin-left: 0;
      margin-right: 0;
      margin: 1em 0;
      padding-left: 40px;
      padding: 40px;
    }
    .reset-this ol {
      display: block;
      list-style-type: decimal;
      margin-top: 1em;
      margin-bottom: 1em;
      margin-left: 0;
      margin-right: 0;
      margin: 1em 0;
      padding-left: 40px;
      padding-left: 40px;
    }
    .reset-this li {
      display: list-item;
      text-align: -webkit-match-parent;
    }
    .reset-this ul ul,
    .reset-this ol ul {
      list-style-type: circle;
    }
    .reset-this ol ol ul,
    .reset-this ol ul ul,
    .reset-this ul ol ul,
    .reset-this ul ul ul {
      list-style-type: square;
    }
    .reset-this dd {
      display: block;
      margin-left: 40px;
      margin-left: 40px;
    }
    .reset-this dl {
      display: block;
      margin-top: 1em;
      margin-bottom: 1em;
      margin-left: 0;
      margin-right: 0;
    }
    .reset-this dt {
      display: block;
    }
    .reset-this ol ul,
    .reset-this ul ol,
    .reset-this ul ul,
    .reset-this ol ol {
      margin-top: 0;
      margin-bottom: 0;
      margin-left: 0;
      margin-right: 0;
    }
    .reset-this form {
      display: block;
      margin-top: 0em;
    }
    .reset-this label {
      cursor: default;
    }
    .reset-this legend {
      display: block;
      padding-left: 2px;
      padding-right: 2px;
      padding-left: 2px;
      padding-right: 2px;
      border: none;
    }
    .reset-this fieldset {
      display: block;
      margin-left: 2px;
      margin-right: 2px;
      -webkit-padding-before: 0.35em;
      padding-left: 0.75em;
      padding-right: 0.75em;
      -webkit-padding-after: 0.625em;
      border: 2px groove ThreeDFace;
      min-width: -webkit-min-content;
    }
    .reset-this button {
      -webkit-appearance: button;
    }
    .reset-this input,
    .reset-this textarea,
    .reset-this keygen,
    .reset-this select,
    .reset-this button,
    .reset-this isindex,
    .reset-this meter,
    .reset-this progress {
      -webkit-writing-mode: horizontal-tb !important;
    }
    .reset-this input,
    .reset-this textarea,
    .reset-this keygen,
    .reset-this select,
    .reset-this button,
    .reset-this isindex {
      margin: 0em;
      color: initial;
      letter-spacing: normal;
      word-spacing: normal;
      line-height: normal;
      text-transform: none;
      text-indent: 0;
      text-shadow: none;
      display: inline-block;
      text-align: start;
    }
    .reset-this input[type="hidden"] {
      display: none;
    }
    .reset-this input,
    .reset-this input:matches([type="password"],
    .reset-this [type="search"]),
    .reset-this isindex {
      -webkit-appearance: textfield;
      background-color: white;
      border: 2px inset;
      padding: 1px;
      -webkit-rtl-ordering: logical;
      -webkit-user-select: text;
      cursor: auto;
    }
    .reset-this input[type="search"] {
      -webkit-appearance: searchfield;
      box-sizing: border-box;
    }
    .reset-this input::-webkit-textfield-decoration-container {
      display: flex;
      align-items: center;
      content: none !important;
    }
    .reset-this input[type="search"]::-webkit-textfield-decoration-container {
      direction: ltr;
    }
    .reset-this input::-webkit-clear-button {
      -webkit-appearance: searchfield-cancel-button;
      display: inline-block;
      flex: none;
      margin-left: 2px;
    }
    .reset-this input[type="search"]::-webkit-search-cancel-button {
      -webkit-appearance: searchfield-cancel-button;
      display: block;
      flex: none;
      align-self: flex-start;
      margin: auto 0;
    }
    .reset-this input[type="search"]::-webkit-search-decoration {
      -webkit-appearance: searchfield-decoration;
      display: block;
      flex: none;
      align-self: flex-start;
      margin: auto 0;
    }
    .reset-this input[type="search"]::-webkit-search-results-decoration {
      -webkit-appearance: searchfield-results-decoration;
      display: block;
      flex: none;
      align-self: flex-start;
      margin: auto 0;
    }
    .reset-this input[type="search"]::-webkit-search-results-button {
      -webkit-appearance: searchfield-results-button;
      display: block;
      flex: none;
    }
    .reset-this input::-webkit-inner-spin-button {
      -webkit-appearance: inner-spin-button;
      display: block;
      position: relative;
      cursor: default;
      height: 1.5em;
      vertical-align: top;
      flex: none;
      -webkit-user-select: none;
    }
    .reset-this input::-webkit-auto-fill-button {
      -webkit-mask-image: -webkit-image-set(url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAMCAYAAAC9QufkAAAAAXNSR0IB2cksfwAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAACXBIWXMAAAsTAAALEwEAmpwYAAADyWlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS40LjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iCiAgICAgICAgICAgIHhtbG5zOnRpZmY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vdGlmZi8xLjAvIgogICAgICAgICAgICB4bWxuczpleGlmPSJodHRwOi8vbnMuYWRvYmUuY29tL2V4aWYvMS4wLyI+CiAgICAgICAgIDx4bXA6TW9kaWZ5RGF0ZT4yMDE1LTA0LTAzVDE2OjA2OjI1PC94bXA6TW9kaWZ5RGF0ZT4KICAgICAgICAgPHhtcDpDcmVhdG9yVG9vbD5BZG9iZSBQaG90b3Nob3AgQ0MgMjAxNCAoTWFjaW50b3NoKTwveG1wOkNyZWF0b3JUb29sPgogICAgICAgICA8eG1wOkNyZWF0ZURhdGU+MjAxNS0wNC0wM1QxNjowMzoxNjwveG1wOkNyZWF0ZURhdGU+CiAgICAgICAgIDx0aWZmOk9yaWVudGF0aW9uPjE8L3RpZmY6T3JpZW50YXRpb24+CiAgICAgICAgIDx0aWZmOllSZXNvbHV0aW9uPjcyPC90aWZmOllSZXNvbHV0aW9uPgogICAgICAgICA8dGlmZjpSZXNvbHV0aW9uVW5pdD4yPC90aWZmOlJlc29sdXRpb25Vbml0PgogICAgICAgICA8dGlmZjpYUmVzb2x1dGlvbj43MjwvdGlmZjpYUmVzb2x1dGlvbj4KICAgICAgICAgPGV4aWY6Q29sb3JTcGFjZT4xPC9leGlmOkNvbG9yU3BhY2U+CiAgICAgICAgIDxleGlmOlBpeGVsWERpbWVuc2lvbj4xNTwvZXhpZjpQaXhlbFhEaW1lbnNpb24+CiAgICAgICAgIDxleGlmOlBpeGVsWURpbWVuc2lvbj4xMjwvZXhpZjpQaXhlbFlEaW1lbnNpb24+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgoz37ZdAAAA5ElEQVQoFY2RsQ5BQRBFd9EgEYXv8QlaEqVGpfUPao3oKXyEQiJI1ERESaGmwnPu2k2QJ2uS82Z2du7s7jyTJInBWnCABeygoXwM6kwN1GELFo7wgOo/4gmFEovzWzyMiTMUlyFYJQT4wlucGko8T90xZv0j/5EusVpCuLr8FPK6NraHPmT8Oks8gI2bKEEOZhAauEJf3PX5Eb4ImpEG2gni0NWJvwdFYRvuoIHeoOUa++56+wpSxb6myf4J6qG5VWCt1ckPvHsksf531HSiDJ1VV9n15eJfJ+YkvWcMF+jFZa+KJ554xIc+jempAAAAAElFTkSuQmCC") 1x,url("data:image/png;base64,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") 2x);
      -webkit-mask-size: 15px 12px;
      width: 15px;
      height: 12px;
      margin-left: 3px;
      margin-right: 2px;
      background-color: black;
      flex: none;
      -webkit-user-select: none;
    }
    .reset-this input::-webkit-auto-fill-button:hover {
      background-color: #007aff;
    }
    .reset-this input::-webkit-auto-fill-button:active {
      background-color: #003cdb;
    }
    .reset-this input::-webkit-caps-lock-indicator {
      -webkit-appearance: caps-lock-indicator;
      content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17"><path fill="black" fill-opacity="0.4" d="M12.5 0.5A 4 4 0 0 1 16.5 4.5L 16.5 12.5A 4 4 0 0 1 12.5 16.5L 4.5 16.5A 4 4 0 0 1 0.5 12.5L 0.5 4.5A 4 4 0 0 1 4.5 0.5L 12.5 0.5M 8.5 2L 4 7L 6.25 7L 6.25 10.25L 10.75 10.25L 10.75 7L 13 7L 8.5 2M 10.75 12L 6.25 12L 6.25 14.25L 10.75 14.25L 10.75 12"/></svg>');
      align-self: stretch;
      flex: none;
      -webkit-user-select: none;
    }
    .reset-this keygen,
    .reset-this select {
      border-radius: 5px;
    }
    .reset-this keygen::-webkit-keygen-select {
      margin: 0px;
    }
    .reset-this textarea {
      -webkit-appearance: textarea;
      -webkit-nbsp-mode: space;
      -webkit-line-break: after-white-space;
      flex-direction: column;
      resize: auto;
      cursor: auto;
      padding: 2px;
      white-space: pre-wrap;
      word-wrap: break-word;
    }
    .reset-this ::-webkit-input-placeholder {
      -webkit-text-security: none;
      color: darkGray;
      pointer-events: none !important;
    }
    .reset-this input::-webkit-input-placeholder,
    .reset-this isindex::-webkit-input-placeholder {
      white-space: pre;
      word-wrap: normal;
      overflow: hidden;
    }
    .reset-this input[type="password"] {
      -webkit-text-security: disc !important;
    }
    .reset-this input:matches([type="hidden"],
    .reset-this [type="image"],
    .reset-this [type="file"]) {
      -webkit-appearance: initial;
      padding: initial;
      background-color: initial;
      border: initial;
    }
    .reset-this input[type="file"] {
      align-items: baseline;
      color: inherit;
      text-align: start !important;
    }
    .reset-this input:-webkit-autofill {
      background-color: #FAFFBD !important;
      background-image: none !important;
      color: #000000 !important;
    }
    .reset-this input:matches([type="radio"],
    .reset-this [type="checkbox"]) {
      margin: 3px 2px;
      padding: initial;
      background-color: initial;
      border: initial;
    }
    .reset-this input:matches([type="button"],
    .reset-this [type="submit"],
    .reset-this [type="reset"]) {
      -webkit-appearance: push-button;
      white-space: pre;
    }
    .reset-this input[type="file"]::-webkit-file-upload-button {
      -webkit-appearance: push-button;
      white-space: nowrap;
      margin: 0;
      font-size: inherit;
    }
    .reset-this input:matches([type="button"],
    .reset-this [type="submit"],
    .reset-this [type="reset"]),
    .reset-this input[type="file"]::-webkit-file-upload-button,
    .reset-this button {
      align-items: flex-start;
      text-align: center;
      cursor: default;
      color: ButtonText;
      padding: 0 1.0em;
      border: 1px solid #4c4c4c;
      background-color: rgba(255,255,255,0.01);
      font: 11px Helvetica;
      box-sizing: border-box;
    }
    .reset-this input:matches([type="button"],
    .reset-this [type="submit"],
    .reset-this [type="reset"]):active,
    .reset-this input[type="file"]::-webkit-file-upload-button:active,
    .reset-this button:active {
      color: ActiveButtonText;
    }
    .reset-this input[type="range"] {
      -webkit-appearance: slider-horizontal;
      padding: initial;
      border: initial;
      margin: 2px;
      color: #909090;
    }
    .reset-this input[type="range"]::-webkit-slider-container,
    .reset-this input[type="range"]::-webkit-media-slider-container {
      flex: 1;
      box-sizing: border-box;
      display: flex;
      align-contents: center;
    }
    .reset-this input[type="range"]::-webkit-slider-runnable-track {
      flex: 1;
      align-self: center;
      box-sizing: border-box;
      display: block;
    }
    .reset-this input[type="range"]::-webkit-slider-thumb,
    .reset-this input[type="range"]::-webkit-media-slider-thumb {
      -webkit-appearance: sliderthumb-horizontal;
      box-sizing: border-box;
      display: block;
    }
    .reset-this input:matches([type="button"],
    .reset-this [type="submit"],
    .reset-this [type="reset"]):disabled,
    .reset-this input[type="file"]:disabled::-webkit-file-upload-button,
    .reset-this button:disabled,
    .reset-this select:disabled,
    .reset-this keygen:disabled,
    .reset-this optgroup:disabled,
    .reset-this option:disabled,
    .reset-this select[disabled]>option {
      color: GrayText;
    }
    .reset-this area,
    .reset-this param {
      display: none;
    }
    .reset-this input[type="checkbox"] {
      -webkit-appearance: checkbox;
      border-radius: 5px;
      width: 16px;
      height: 16px;
      padding: 0px;
      background-color: rgba(255,255,255,0.01);
    }
    .reset-this select {
      box-sizing: border-box;
      -webkit-appearance: menulist;
      border: 1px solid;
      color: black;
      background-color: white;
      align-items: center;
      white-space: pre;
      -webkit-rtl-ordering: logical;
      cursor: default;
    }
    .reset-this optgroup {
      font-weight: bolder;
    }
    .reset-this option {
      font-weight: normal;
    }
    .reset-this output {
      display: inline;
    }
    .reset-this ::-webkit-validation-bubble {
      display: inline-block;
      z-index: 2147483647;
      position: absolute;
      opacity: 0.95;
      line-height: 0;
      margin: 0;
      -webkit-text-security: none;
      transition: opacity 05.5s ease;
    }
    .reset-this ::-webkit-validation-bubble-message {
      display: flex;
      position: relative;
      top: -4px;
      font: message-box;
      color: black;
      min-width: 50px;
      max-width: 200px;
      border: solid 2px #400;
      background: -webkit-gradient(linear,left top,left bottom,from(#f8ecec),to(#e8cccc));
      padding: 8px;
      border-radius: 8px;
      -webkit-box-shadow: 4px 4px 4px rgba(100,100,100,0.6), inset -2px -2px 1px #d0c4c4, inset 2px 2px 1px white;
      line-height: normal;
      white-space: normal;
      z-index: 2147483644;
    }
    .reset-this ::-webkit-validation-bubble-text-block {
      flex: 1;
    }
    .reset-this ::-webkit-validation-bubble-heading {
      font-weight: bold;
    }
    .reset-this ::-webkit-validation-bubble-arrow {
      display: inline-block;
      position: relative;
      left: 32px;
      width: 16px;
      height: 16px;
      background-color: #f8ecec;
      border-width: 2px 0 0 2px;
      border-style: solid;
      border-color: #400;
      box-shadow: inset 2px 2px 1px white;
      -webkit-transform-origin: 0 0;
      transform: rotate(45deg);
      z-index: 2147483645;
    }
    .reset-this ::-webkit-validation-bubble-arrow-clipper {
      display: block;
      overflow: hidden;
      height: 16px;
    }
    .reset-this progress {
      -webkit-appearance: progress-bar;
      box-sizing: border-box;
      display: inline-block;
      height: 1em;
      width: 10em;
      vertical-align: -0.2em;
    }
    .reset-this progress::-webkit-progress-inner-element {
      -webkit-appearance: inherit;
      box-sizing: inherit;
      height: 100%;
      width: 100%;
    }
    .reset-this progress::-webkit-progress-bar {
      background-color: gray;
      height: 100%;
      width: 100%;
      box-sizing: border-box;
    }
    .reset-this progress::-webkit-progress-value {
      background-color: green;
      height: 100%;
      width: 50%;
      box-sizing: border-box;
    }
    .reset-this u,
    .reset-this ins {
      text-decoration: underline;
    }
    .reset-this strong,
    .reset-this b {
      font-weight: bold;
    }
    .reset-this i,
    .reset-this cite,
    .reset-this em,
    .reset-this var,
    .reset-this address,
    .reset-this dfn {
      font-style: italic;
    }
    .reset-this tt,
    .reset-this code,
    .reset-this kbd,
    .reset-this samp {
      font-family: monospace;
    }
    .reset-this pre,
    .reset-this xmp,
    .reset-this plaintext,
    .reset-this listing {
      display: block;
      font-family: monospace;
      white-space: pre;
      margin: 1em 0;
    }
    .reset-this mark {
      background-color: yellow;
      color: black;
    }
    .reset-this big {
      font-size: larger;
    }
    .reset-this small {
      font-size: smaller;
    }
    .reset-this s,
    .reset-this strike,
    .reset-this del {
      text-decoration: line-through;
    }
    .reset-this sub {
      vertical-align: sub;
      font-size: smaller;
    }
    .reset-this sup {
      vertical-align: super;
      font-size: smaller;
    }
    .reset-this nobr {
      white-space: nowrap;
    }
    .reset-this :focus {
      outline: auto;
    }
    .reset-this html:focus,
    .reset-this body:focus,
    .reset-this input[readonly]:focus,
    .reset-this applet:focus,
    .reset-this embed:focus,
    .reset-this iframe:focus,
    .reset-this object:focus {
      outline: none;
    }
    .reset-this input:matches([type="button"],
    .reset-this [type="checkbox"],
    .reset-this [type="file"],
    .reset-this [type="hidden"],
    .reset-this [type="image"],
    .reset-this [type="radio"],
    .reset-this [type="reset"],
    .reset-this [type="search"],
    .reset-this [type="submit"]):focus,
    .reset-this input[type="file"]:focus::-webkit-file-upload-button {
      outline-offset: 0;
    }
    .reset-this a:any-link {
      color: -webkit-link;
      text-decoration: underline;
      cursor: auto;
    }
    .reset-this a:any-link:active {
      color: -webkit-activelink;
    }
    .reset-this ruby,
    .reset-this rt {
      text-indent: 0;
    }
    .reset-this rt {
      line-height: normal;
      -webkit-text-emphasis: none;
    }
    .reset-this ruby > rt {
      display: block;
      font-size: -webkit-ruby-text;
      text-align: start;
    }
    .reset-this ruby > rp {
      display: none;
    }
    .reset-this noframes {
      display: none;
    }
    .reset-this frameset,
    .reset-this frame {
      display: block;
    }
    .reset-this frameset {
      border-color: inherit;
    }
    .reset-this iframe {
      border: 2px inset;
    }
    .reset-this details {
      display: block;
    }
    .reset-this summary {
      display: block;
    }
    .reset-this summary::-webkit-details-marker {
      display: inline-block;
      width: 0.66em;
      height: 0.66em;
      margin-right: 0.4em;
    }
    .reset-this bdi,
    .reset-this output {
      unicode-bidi: -webkit-isolate;
    }
    .reset-this bdo {
      unicode-bidi: bidi-override;
    }
    .reset-this ol li{
        list-style-type: decimal;
    }
</style>